module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-1800.5cbb7adc.svg";